import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import FilterButton from './FilterButton';


class Filters extends Component {

  render() {
    const {filterOptions, appliedFilters, entity} = this.props;
    const filterButtons = Object.keys(filterOptions).filter(key => key.trim()).map(filter => {
      const isApplied = appliedFilters.includes(filter);
      const hasSpotsForFilter = (filterOptions[filter].length > 0);

      return (
        <FilterButton key={filter}
                      isApplied={isApplied}
                      hasSpotsForFilter={hasSpotsForFilter}
                      filter={filter}
                      entity={entity} />
      );
    });

    return (
      <div className="form-group">
        <label htmlFor="" className="block">
          {entity}
        </label>


        <FilterButton key={'all'}
                      isApplied={appliedFilters.length === 0}
                      hasSpotsForFilter={true}
                      filter={"All"}
                      entity={entity}
        />

        {filterButtons}
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);



// WEBPACK FOOTER //
// ./src/containers/Search/Filters.js